package top.wcpe.allincore.ui.runtime.render.model

/**
 * 渐变类型枚举。
 *
 * ADR-0072 决策 1 镜像：真源为 `platform-client-api` 的
 * `top.wcpe.allincore.platform.client.api.render.command.GradientType`
 * （纯 Java 8 对外 API，按 ADR-0002 不得 KMP 化）。值名与声明序逐一照抄真源，
 * 一致性由 jvmTest 的 RenderModelConsistencyTest 守护。
 */
enum class GradientType {
    /** 无渐变 */
    NONE,

    /** 线性渐变 */
    LINEAR,

    /** 径向渐变 */
    RADIAL,
}
